import React from "react";

import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";

import {
  Query,
  QueryGetFactureByIdArgs,
} from "../../graphql/__generated__/types";
import { GET_FACTURES_BY_ID } from "../../graphql/factures/query";

const FactureView: React.FC = () => {
  const { id } = useParams();
  const { data, loading } = useQuery<Query, QueryGetFactureByIdArgs>(
    GET_FACTURES_BY_ID,
    {
      fetchPolicy: "cache-first",
      variables: {
        id: Number(id?.slice(4, -4)),
      },
    },
  );

  if (!loading && !data?.GetFactureById) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <h1>Not found</h1>
        <p>The resource could not be found.</p>
      </div>
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/iframe-has-title
    <iframe
      loading="lazy"
      src={data?.GetFactureById?.url || undefined}
      width="100%"
      height="100vh"
      style={{ height: "100vh" }}
    />
  );
};

export default FactureView;
